'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';

export default function NotFound() {
    const router = useRouter();

    const handleGoBack = () => {
        if (typeof window !== 'undefined') {
            window.history?.back();
        }
    };

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-background p-4">
            <div className="text-center max-w-md">
                <div className="flex justify-center mb-6" aria-hidden="true">
                    <p className="text-9xl font-bold text-primary opacity-20">404</p>
                </div>

                <h1 className="text-2xl font-medium text-foreground mb-2">Pagina Non Trovata</h1>
                <p className="text-muted-foreground mb-8">
                    La pagina che stai cercando non esiste. Torniamo alla home!
                </p>

                <div className="flex flex-col sm:flex-row gap-4 justify-center">
                    <button
                        onClick={handleGoBack}
                        aria-label="Torna alla pagina precedente"
                        className="inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3 rounded-lg font-medium hover:bg-primary/90 transition-colors duration-200 min-h-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
                    >
                        ← Torna Indietro
                    </button>

                    <Link
                        href="/call-dashboard"
                        className="inline-flex items-center justify-center gap-2 border border-border bg-background text-foreground px-6 py-3 rounded-lg font-medium hover:bg-muted transition-colors duration-200 min-h-[44px] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2"
                    >
                        <span aria-hidden="true">🏠</span> Vai alla Home
                    </Link>
                </div>
            </div>
        </div>
    );
}